import { render, staticRenderFns } from "./FirmData.vue?vue&type=template&id=4c73d203&"
import script from "./FirmData.vue?vue&type=script&lang=js&"
export * from "./FirmData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports